var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"suspension"}},[_vm._m(0),_vm._t("deles")],2)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"suspension-wrap"},[_c('img',{staticClass:"suspension-logo",attrs:{"src":"https://imgs.starfirelink.com/vue-fire-start-h5/shop-peison/icon_back_36.png"}})])
}]

export { render, staticRenderFns }